export function loadCSS(path) {
  const existingCSS = document.getElementById('theme-css');
  if (existingCSS) {
    if (existingCSS.path !== path) {
      existingCSS.remove();
    } else {
      return;
    }
  }
  const link = document.createElement('link');
  link.id = 'theme-css';
  link.rel = 'stylesheet';
  link.href = path;
  document.head.appendChild(link);
}
